<template>
  <div class="box">
    <div
      class="modal"
      :class="{ 'is-active': modal }"
    >
      <div class="modal-background" />
      <div class="modal-content">
        <Component
          :is="component"
          @saved="onSaveUser"
          @find="onFindUsers"
        />
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="onCloseModal"
      />
    </div>
    <div class="title-container is-flex">
      <h1 class="title is-4 has-text-primary">
        Usuarios
      </h1>
      <div class="buttons-container">
        <div class="field is-grouped">
          <p class="control">
            <a
              class="button is-info"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="openModal('FindUser')"
            >
              <BIcon icon="magnify" />
              <span>Buscar Usuarios</span>
            </a>
          </p>
          <p class="control">
            <a
              class="button is-success"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="openModal('NewUser')"
            >
              <BIcon icon="plus" />
              <span>Nuevo Usuario</span>
            </a>
          </p>
          <p class="control">
            <a
              class="button is-primary"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="openModal('CsvLoad')"
            >
              <BIcon icon="cloud-upload" />
              <span>Carga Masiva</span>
            </a>
          </p>
          <p class="control">
            <a
              class="button is-primary"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="downloadUsers()"
            >
              <BIcon icon="cloud-download" />
              <span>Descarga Csv</span>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div
      class="title-container is-flex"
      style="justify-content:flex-end"
    >
      <h1 class="title is-6 has-text-primary">
        {{ partialCount }}
      </h1>
    </div>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
    <div
      v-if="users.length > 0"
      class="table-container"
    >
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th
              v-if="$store.state.ui.isTelum"
              class="is-hidden-mobile is-hidden-tablet-only"
            >
              Teléfono
            </th>
            <th class="is-hidden-mobile is-hidden-tablet-only">
              Nombre Comercial
            </th>
            <th>RFC</th>
            <th>Número de cuenta</th>
            <th>Proyecto</th>
            <th>Estatus multi usuario</th>
            <th class="is-hidden-mobile">
              Fecha de Alta
            </th>
            <th class="is-hidden-mobile" />
            <th v-if="users.length > 0" />
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th
              v-if="$store.state.ui.isTelum"
              class="is-hidden-mobile is-hidden-tablet-only"
            >
              Teléfono
            </th>
            <th class="is-hidden-mobile is-hidden-tablet-only">
              Nombre Comercial
            </th>
            <th>RFC</th>
            <th>Número de cuenta</th>
            <th>Proyecto</th>
            <th>Estatus multi usuario</th>
            <th class="is-hidden-mobile">
              Fecha de Alta
            </th>
            <th class="is-hidden-mobile" />
            <th v-if="users.length > 0" />
          </tr>
        </tfoot>
        <tbody>
          <tr
            v-for="(user, index) in users"
            :key="index"
          >
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td
              v-if="$store.state.ui.isTelum"
              class="is-hidden-mobile is-hidden-tablet-only"
            >
              {{ user.phoneNumber }}
            </td>
            <td class="is-hidden-mobile is-hidden-tablet-only">
              {{ user.tradeName }}
            </td>
            <td>{{ user.rfc }}</td>
            <td>{{ user.accountNumber }}</td>
            <td>{{ user.projectName }}</td>
            <td>{{ user.multiUser }}</td>
            <td class="is-hidden-mobile">
              {{ user.createdAt | toHumanDate }}
            </td>
            <td>
              <div class="actions is-centered">
                <AppRadialMenu
                  :size="36"
                  :item-size="48"
                  :radius="80"
                  :angle-restriction="50"
                  :rotate="-25"
                >
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-info has-background-info has-text-white"
                    data-tooltip="Reenviar Email"
                  >
                    <a
                      class="action-option"
                      :class="{ 'is-loading': sendEmailLoading }"
                      :disabled="sendEmailLoading"
                      @click="sendEmail(user.email)"
                    >
                      <BIcon
                        icon="send"
                        class="action-option-icon"
                      />
                    </a>
                  </AppRadialMenuItem>

                  <AppRadialMenuItem
                    class="tooltip is-tooltip-link has-background-link has-text-white"
                    data-tooltip="Editar Datos"
                  >
                    <a
                      class="action-option"
                      :class="{ 'is-loading': isLoading }"
                      :disabled="isLoading"
                      @click="openModal('UpdateUser', user)"
                    >
                      <BIcon
                        icon="pencil"
                        class="action-option-icon"
                      />
                    </a>
                  </AppRadialMenuItem>
                </AppRadialMenu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <section class="section">
        <b-notification :closable="false">
          <div class="content has-text-grey has-text-centered">
            <p>
              <BIcon
                icon="emoticon-sad"
                size="is-large"
              />
            </p>
            <p>No tienes ningún cliente</p>
          </div>
          <b-loading
            :is-full-page="isFullPage"
            :active.sync="isLoading"
            :can-cancel="false"
          />
        </b-notification>
      </section>
    </div>
    <section class="section">
      <b-loading
        :is-full-page="isFullPage"
        :active.sync="ischange"
        :can-cancel="false"
      />
    </section>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'UsersList',
  components: {
    AppPagination: () => import(/* webpackChunkName: "app-pagination" */ '@/components/AppPagination.vue'),
    NewUser: () => import(/* webpackChunkName: "new-user-pending-to-move" */ '@/components/SuperAdmin/NewUser.vue'),
    CsvLoad: () => import(/* webpackChunkName: "users-csv-load" */ '@/components/SuperAdmin/UsersCsvLoad.vue'),
    UpdateUser: () => import(/* webpackChunkName: "update-user" */ '@/components/SuperAdmin/UpdateUser.vue'),
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '@/components/AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '@/components/AppRadialMenuItem.vue'),
    FindUser: () => import(/* webpackChunkName: "find-user" */ '@/components/SuperAdmin/FindUser.vue'),
  },
  data() {
    return {
      isLoading: false,
      sendEmailLoading: false,
      modal: false,
      component: '',
      userRow: null,
      buttonsMax: 5,
      isFullPage: true,
      ischange: false,
    };
  },
  computed: {
    ...mapState({
      users: state => state.users.list,
      count: state => state.users.count,
      totalPages: state => state.users.totalPages,
      total: state => state.users.total,
    }),
    lastPage() {
      return Math.ceil(this.users.length / this.itemsPerPage);
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return this.$route.query.size;
    },
    partialCount() {
      if (this.count - (this.currentPage - 1) * 20 > 20) {
        return `${(this.currentPage - 1) * 20 + 1} - ${this.currentPage
          * 20} de ${this.count}`;
      }
      if (this.count === 0) {
        return '0-0 de 0';
      }
      return `${(this.currentPage - 1) * 20 + 1} - ${this.count} de ${
        this.count
      }`;
    },
  },
  watch: {
    currentPage() {
      this.ischange = false;
    },
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20 } });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const { page = 1, size = 20 } = to.query;
    await this.getUsers({
      page,
      size,
    });
    next({ query: { page, size } });
  },
  async beforeMount() {
    try {
      this.setValue({ accessor: 'email', value: '' });
      this.isLoading = true;
      await this.getUsers({
        page: this.currentPage,
        size: this.size,
      });
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  mounted() {
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && this.modal) {
          this.modal = false;
        }
      },
      false,
    );
  },
  beforeDestroy() {
    document.removeEventListener('keydown', () => {});
  },

  methods: {
    ...mapActions({
      getUsers: 'users/get',
      forgottenPassword: 'auth/forgottenPassword',
    }),
    ...mapMutations({
      setValue: 'users/setValue',
    }),
    async downloadUsers() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('users/getAll');

      this.$store.commit('ui/deleteNotification', now);
    },
    openModal(component, userRow) {
      this.component = component;
      if (userRow) {
        const {
          rfc,
          companyName,
          tradeName,
          accountNumber,
          projectName,
          email,
          name,
          userId,
          employerRegistration,
          phoneNumber,
          multiUser,
        } = userRow;

        this.$store.commit('users/setValues', {
          name,
          email,
          userId,
          phoneNumber,
          company: {
            rfc,
            name: companyName,
            tradeName,
            accountNumber,
            projectName,
            oldRfc: rfc,
            employerRegistration,
            multiUser,
          },
        });
      }
      this.modal = true;
    },
    onCloseModal() {
      this.modal = false;
      this.component = '';
    },
    async onSaveUser() {
      try {
        this.setValue({ accessor: 'email', value: '' });
        this.isLoading = true;
        await this.getUsers({
          page: this.currentPage,
          size: this.size,
        });
        this.onCloseModal();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async onFindUsers() {
      this.onCloseModal();
      this.isLoading = false;
    },
    async sendEmail(email) {
      this.sendEmailLoading = true;
      try {
        await this.forgottenPassword(email);
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Se envió el correo correctamente.',
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: 'Ocurrió un error al enviar el correo.',
        });
      }
      this.sendEmailLoading = false;
    },
    goToPage(page) {
      this.$router.push({ query: { page } });
      this.ischange = true;
    },
    checkLastPage() {
      if (this.currentPage < this.lastPage) {
        this.$router.push({ query: { page: this.lastPage } });
      }
    },
  },
};
</script>

<style scoped>
.empty {
  text-align: center;
}

.loading-overlay,
.loading-background {
  position: fixed !important;
  z-index: 1000 !important;
}

.title-container.is-flex {
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  flex-wrap: wrap;
}

.title {
  margin-bottom: 0;
}

.button.is-primary {
  padding-left: 1.25rem;
}

@media screen and (max-width: 768px) {
  .title {
    margin-bottom: 1rem;
  }
}
</style>
